<div class="px-0">
	<div class="row align-items-md-center">
		<div class="col-10 col-md-3" [hidden]="hideSearch"><app-table-filter></app-table-filter></div>
		<div class="col-1 col-md-3">
			@if (enableDynamicFilter) {
				@if (isHidden) {
					<i (click)="onOffFilter()" class="mdi mdi-filter-off fs-4 text-muted"></i>
				} @else {
					<i (click)="onOffFilter()" class="mdi mdi-filter fs-4 text-muted"></i>
				}
			}
		</div>
	</div>

	<div class="row">
		<div class="col-12">
			<app-dynamic-filter #filterChild [hidden]="isHidden" [collection]="collection" [fields]="fields" (searchResults)="onSearchResults($event)"></app-dynamic-filter>
		</div>
	</div>
</div>
<div class="table-responsive table-card m-table min-h-table">
	<table appResponsiveTable class="table align-top table-striped table-hover mb-0" style="table-layout: fixed">
		<thead>
			<tr class="bg-light text-muted">
				@for (col of columns; track $index) {
					<th [ngClass]="col.sortable == true ? 'sort' : ''" (click)="col.sortable && onSort(col.name)" [style]="'width:' + (col.width !== undefined ? col.width : '80%')">
						{{ col.label | titlecase }}
					</th>
				}
			</tr>
		</thead>
		<tbody>
			@if (dataLoading == true) {
				<tr>
					<td colspan="20" class="text-center" style="padding: 18px 0px">Chargement encours...</td>
				</tr>
			} @else {
				@if (data.length == 0) {
					<tr>
						<td colspan="20" class="text-center" style="padding: 18px 0px">Aucun enregistrement trouvé</td>
					</tr>
				} @else {
					@for (item of data; track $index) {
						<tr class="fw-medium">
							@for (col of columns; track $index) {
								<td style="vertical-align: middle" [style.width]="col.width" [class]="col.tdClass">
									@switch (col.type) {
										@case (COL_TYPES.IMG) {
											<img [src]="backendUrl + item[col.name]" [class]="col.class" />
										}
										@case (COL_TYPES.DATE) {
											<span [class]="col.class">{{ item[col.name] | dateFormatPipe: "date" }}</span>
										}
										@case (COL_TYPES.BOOLEAN) {
											<span [class]="col.class">
												@if (item[col.name] == true) {
													OUI
												} @else if (item[col.name] == false) {
													NOM
												} @else {}
											</span>
										}
										@case (COL_TYPES.PASSWORD) {
											<span [class]="col.class">*****</span>
										}
										@case (COL_TYPES.RELATION) {
											<span [class]="col.class" class="text-break">{{ getRelationValue(item, col) }}</span>
										}
										@case (COL_TYPES.EXPORT) {
											<span
												class="badge rounded-pill fw-medium p-2"
												[ngClass]="{
													'bg-light text-dark': item[col.name] === false,

													'bg-success-subtle text-success': item[col.name] === true
												}"
											>
												@if (item[col.name] == true) {
													OUI
												} @else if (item[col.name] == false) {
													NON
												} @else {}
											</span>
										}
										@case (COL_TYPES.OBJECT) {
											<span [class]="col.class" class="text-break" [title]="getObjectDisplayValue(item, col)">
												{{ getObjectDisplayValue(item, col) }}
											</span>
										}
										@case (COL_TYPES.BADGE) {
											@if (item[col.name]) {
												<span class="badge rounded-pill fw-medium p-2" [ngClass]="getBadgeClass(item[col.name], col.badge)">
													{{ getBadgeLabel(item[col.name], col.badge) | titlecase }}
												</span>
											} @else {
												<p class="p-2">----</p>
											}
										}
										@case (COL_TYPES.FILE) {
											@if (item[col.name]) {
												<gm-icon-button icon="las la-eye" color="info" (clicked)="viewFile(item[col.name])"></gm-icon-button>
											} @else {
												<span class="text-muted">-</span>
											}
										}
										@case (COL_TYPES.ACTION) {
											<div class="d-flex gap-2">
												@if (!isLectureSeule) {
													@if (!options?.hideDefaultActions && canEdit(item)) {
														<gm-icon-button icon="bx bx-edit" color="success" (click)="openModal(item.id)"></gm-icon-button>
													}
													@if (!options?.hideDefaultActions && canDelete(item)) {
														<gm-icon-button icon="ri-delete-bin-line" color="danger" (click)="onDelete(item.id)"></gm-icon-button>
													}
													@if (customActionsTemplate) {
														<ng-container *ngTemplateOutlet="customActionsTemplate; context: { $implicit: item, item: item }"></ng-container>
													}
												}
											</div>
										}
										@case (COL_TYPES.CUSTOM) {
											<span [innerHTML]="col.renderHtml ? col.renderHtml(item) : '—'"></span>
										}
										@default {
											<span [ngClass]="col.class" class="text-truncate d-inline-block w-100" [title]="item[col.name]">
												@if (item[col.name] == null || item[col.name] == undefined || item[col.name] == "") {
													----
												} @else {
													{{ item[col.name] }}
												}
											</span>
										}
									}
								</td>
							}
						</tr>
					}
				}
			}
		</tbody>
	</table>
</div>
<div class="float-end">
	<ngb-pagination [collectionSize]="pageTotal" [(page)]="page" [pageSize]="pageSize" [maxSize]="2" (pageChange)="onPaginate($event)"></ngb-pagination>
</div>

<ng-template #modalEdit let-modal>
	<form [formGroup]="editForm" (ngSubmit)="onFormSubmit()">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title" id="varyingcontentModalLabel">{{ title }} - Editer</h4>
				<button type="button" class="btn-close" aria-hidden="true" (click)="modal.dismiss('Cross click')"></button>
			</div>
			<div class="modal-body">
				<div class="row g-4">
					@for (col of getEditableColumns(); track $index) {
						@if (col.type === COL_TYPES.RELATION) {
							<div [ngClass]="col.col !== undefined ? col.col : 'col-xxl-12'">
								<label>{{ col.label }}</label>
								<ng-select
									[items]="relationData[col.name]"
									[bindValue]="col.relation.valueField"
									[bindLabel]="col.relation.displayField"
									[clearable]="true"
									[searchable]="true"
									[placeholder]="col.label"
									[formControlName]="col.name"
								>
								</ng-select>
							</div>
						} @else if (col.enumeration != undefined) {
							<div [ngClass]="col.col !== undefined ? col.col : 'col-xxl-12'">
								<label>{{ col.label }}</label>
								<ng-select [items]="col.enumeration" [clearable]="true" [searchable]="false" [placeholder]="col.label" [formControlName]="col.name"> </ng-select>
							</div>
						} @else {
							<div [ngClass]="col.col !== undefined ? col.col : 'col-xxl-12'">
								<label>{{ col.label }}</label>
								@if (col.type == COL_TYPES.PASSWORD) {
									<input type="password" class="form-control" [placeholder]="col.label" [formControlName]="col.name" />
								} @else {
									<input type="text" class="form-control" [placeholder]="col.label" [formControlName]="col.name" />
								}
							</div>
						}
					}
				</div>
			</div>
			<div class="modal-footer">
				<button type="submit" class="btn btn-primary w-xl">تأكيد</button>
			</div>
		</div>
	</form>
</ng-template>
